import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_VIDEO_URL_DATA = "paginationVideoUrlData";
export const VIDEO_CREATE_DATA = "videoData";
export const PUT_VIDEO_DATA = "putVideoData";
export const GET_VIDEO_DATA = "getVideoData";
export const CLEAR_PAGINATION = "clearPagination";
export const SET_STATE_PRAM_VIDEO = "setStarePramVideo";
export const DELETE_VIDEO_DATA = "deleteVideoData";

export default {
  state: {
    path: "video",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: "",
      data_pram:''
    }
  },
  getters: {},
  actions: {
    [PAGINATION_VIDEO_URL_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [VIDEO_CREATE_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.put(
          `${context.state.path}/${payload.id}`,
          payload.data
        );
      },
      [PUT_VIDEO_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.put(
          `${context.state.path}/update/${payload.id}`,
          payload.data
        );
      },
      [GET_VIDEO_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.getParams(`${context.state.path}/${payload.id}`);
      },
      [DELETE_VIDEO_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.delete(`${context.state.path}/${payload.id}`);
      }
  },
  mutations: {
    [SET_STATE_PRAM_VIDEO](state, payload) {
        state.data_pram = payload;
      },
      [CLEAR_PAGINATION](state) {
        state.pagination = {
          page: 1,
          perPage: 25,
          orderBy: "id",
          isDesc: true,
          sortDirection: "asc",
          filter: ""
        };
      }
  }
};
